import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import getLocale from '../../../i18n/getLocale';

class DesignationCustomRequisitionsModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      modal: false,
      designation_requisition_id: this.props.designation_requisition_id,
      name: this.props.designation_requisition.name,
      type: this.props.designation_requisition.type,
      hours_limit: this.props.designation_requisition.hours_limit,
      days: this.props.designation_requisition.days,
      exception: this.props.designation_requisition.exception,
    };
    //bind específico
    this.closeModal = this.closeModal.bind(this);

    this.editRequisition = this.editRequisition.bind(this);

    // Handler
    this.locale = getLocale();

  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    this.setState({
      designation_requisition_id: newProps.designation_requisition.id,
      name: newProps.designation_requisition.name,
      hours_limit: newProps.designation_requisition.hours_limit,
      type: newProps.designation_requisition.type,
      days: newProps.designation_requisition.days,
      exception: newProps.designation_requisition.exception,
    });
    if (newProps.modal_props === true) {
      this.setState({ modal: true});
    }
  }

  closeModal() {
    this.setState({
      modal: false,
      designation_requisition_id: undefined,
    }, this.props.closeModalParent());
  }

  editRequisition(event) {
    event.preventDefault();
    var datasave = {
      designation_requisition_id: this.state.designation_requisition_id,
      name: this.state.name,
      hours_limit: this.state.hours_limit,
      type: this.state.type,
      days: this.state.days,
    };
    var self = this;
    self.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/designacao/requisicao/personalizada', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.props.loadData(responseJson);
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
    <RequestApi ref={'request_api'} />
    <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
      <Modal.Header>
        <h4 className="pull-left">{this.locale.Designacoes.EditarDesignacao.tabRequisitosPersonalizados.tituloEditarRequisitos}</h4>
        <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
        <i className="fa fa-fw fa-close"></i></button>
        <div className="clearfix"></div>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={this.editRequisition}> 
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosPersonalizados.formularioEditarRequisito.Nome}:</label>
                <input value={this.state.name} name="name" className="form-control" onChange={this.handleChange.bind(this, 'name')} placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosPersonalizados.formularioEditarRequisito.placeholder.Nome} />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosPersonalizados.formularioEditarRequisito.Tipo}:</label>
                <Select
                  className="form-field-name"
                  name="type"
                  value={this.state.type}
                  searchable={true}
                  placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosPersonalizados.formularioEditarRequisito.placeholder.SelecionarTipo}
                  onChange={this.handleSelectChange.bind(this, 'type')}
                  options={[
                      {value: "hours_total", label: this.locale.Designacoes.EditarDesignacao.tabRequisitosPersonalizados.formularioEditarRequisito.opcoesTipo.LimiteDeHorasDeVoo},
                      {value: "hours_journey", label: this.locale.Designacoes.EditarDesignacao.tabRequisitosPersonalizados.formularioEditarRequisito.opcoesTipo.LimiteDeHorasDeJornada},
                  ]}
                required
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosPersonalizados.formularioEditarRequisito.LimiteDeHoras}:</label>
                <input value={this.state.hours_limit} name="hours_limit" className="form-control" onChange={this.handleChange.bind(this, 'hours_limit')} placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosPersonalizados.formularioEditarRequisito.placeholder.limite} />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosPersonalizados.formularioEditarRequisito.DiasCorridos}:</label>
                <input value={this.state.days} name="days" className="form-control" onChange={this.handleChange.bind(this, 'days')} placeholder="Total de dias corridos" required />
              </div>
            </div>
          </div>
          <div className="row">
          </div>
          <div className="row">
            <div className="col-md-12">
              <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Designacoes.EditarDesignacao.tabRequisitosPersonalizados.formularioEditarRequisito.botaoEditarRequisito}</button>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
        <i className="fa fa-fw fa-close"></i></button>
      </Modal.Footer>
    </Modal>
</div>
    );
  }
}

export default DesignationCustomRequisitionsModal;



// WEBPACK FOOTER //
// ./src/Components/Designations/Elements/DesignationCustomRequisitionsModal.js